export const FLAGS = {
  argentina: '🇦🇷',
  brasil: '🇧🇷',
  uruguay: '🇺🇾',
  alemania: '🇩🇪',
  paises_bajos: '🇳🇱',
  noruega: '🇳🇴',
  belgica: '🇧🇪',
  inglaterra: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  espana: '🇪🇸',
  portugal: '🇵🇹',
  francia: '🇫🇷',
  eslovenia: '🇸🇮'
};

export type CountryCode = keyof typeof FLAGS;
